import { BucketVendor } from "@prequel/react";

// Fields set by the magic link and locked in the form
const FIXED_FIELDS = [
  "name",
  "vendor",
  "host",
  "bucket_vendor",
  "storage",
  "bucket_name",
  "container_name",
  "storage_account_name",
  "metastore",
  "project_id",
];

export const isFixedField = (fieldName: string): boolean => FIXED_FIELDS.includes(fieldName);

// New API version prefixes the bucket vendor with bucket_
export const getBucketVendor = (bucketVendor?: string): BucketVendor | undefined =>
  bucketVendor ? (("bucket_" + bucketVendor) as BucketVendor) : undefined;
